<nz-modal
  [nzVisible]="hasEmptyCountryIso$ | async"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  [nzCancelText]="null"
  [nzOkText]="'SAVE' | translate"
  [nzOkLoading]="updating$ | async"
  [nzOkDisabled]="form.invalid"
  (nzOnOk)="updateCountryIso()"
>
  <ng-container *nzModalContent>
    <div class="country-config-content">
      <h3>Пожалуйста, укажите вашу страну</h3>
      <p>Please, specify your country</p>

      <form nz-form nzLayout="vertical" [formGroup]="form">
        <nz-form-item>
          <nz-form-label nzRequired>
            Country
          </nz-form-label>

          <nz-form-control nzErrorTip="Please, specify your country">
            <nz-select
              formControlName="country"
              id="country"
              nzSize="large"
              nzShowSearch
              nzPlaceHolder="Country"
              [nzCustomTemplate]="selectedCountryTemplate"
            >
              <nz-option
                *ngFor="let country of countries"
                [nzLabel]="country.name"
                [nzValue]="country.code"
                nzCustomContent
              >
                <span>{{ country.emoji }}</span>
                &nbsp;
                <span class="country-name">{{ country.name }}</span>
              </nz-option>
            </nz-select>

            <ng-template #selectedCountryTemplate let-selected>
              <span>{{ countriesMap[selected.nzValue]?.emoji }}</span>
              &nbsp;
              <span class="country-name">
                {{ countriesMap[selected.nzValue]?.name }}
              </span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
  </ng-container>
</nz-modal>
